import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Comment } from 'src/app/models/comment.model';
import { Toast, ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';
import { formatDate } from '@angular/common'

@Component({
  selector: 'app-teacher-comments',
  templateUrl: './teacher-comments.component.html',
  styleUrls: ['./teacher-comments.component.css']
})
export class TeacherCommentsComponent implements OnInit {

  showSpinner:boolean = false

  comments:Comment[] = []

  showDialog:boolean = false

  commentId:string = ''

  user:any

  constructor(
    private firestore:AngularFirestore,
    private toastr: ToastrService,
    private courseService:CourseService
  ) { }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.firestore.collection('comments').snapshotChanges().subscribe(snapshot => {

      var comments = snapshot.map(function (item) {
        var comment = item.payload.doc.data() as Comment;
        const id = item.payload.doc.id
        comment.id = id
        return comment
      })
      
      
      comments = comments.filter(comment => comment.teacherId === this.user.uid)

      comments.sort((a, b) => (a.updatedAt > b.updatedAt ? -1 : 1));

      this.comments = comments;


    });
  }

  onShowReplyDialog(commentId){
    this.commentId = commentId
    this.showDialog = true
  }

  onDismissDialog(){
    this.showDialog = false
  }
  onReply(text){
    if(text === ''){
      this.toastr.error('Please enter text!')
      return
    }
    let now = formatDate(new Date(), 'MMM-dd-yyyy HH:mm:aa', 'en_US')
    const commentDesc = {
      date:now,
      text:text,
      displayName:'Teacher'
    }
    this.showDialog = false
    console.log(commentDesc)
    this.courseService.addReplyComment(this.commentId,commentDesc).subscribe(result=>{
      if(result.result){
        this.toastr.success('Replied comment succefully.')
      }else{
        this.toastr.error('Failed to reply!')
      }
    })
  }

}
